import {
  all as allIntegrationSystems,
  new as newIntegrationSystem,
  edit as editIntegrationSystem
} from 'pages/integrationSystems'

export default [
  {
    path: '/integration-systems',
    name: 'integrationSystems.all',
    component: allIntegrationSystems,
    meta: {permits: ['super_admin']}
  },
  {
    path: '/integration-systems/new',
    name: 'integrationSystems.new',
    component: newIntegrationSystem,
    meta: {permits: ['super_admin']}
  },
  {
    path: '/integration-systems/edit/:id',
    name: 'integrationSystems.edit',
    component: editIntegrationSystem,
    meta: {permits: ['super_admin']}
  }
]
